import { Form, FormItemProps } from "antd";
import classes from "./styles.module.css";

export function FormItem({ className = "", ...rest }: FormItemProps) {
  return <Form.Item {...rest} className={[classes.formItem, className].join(" ")} />;
}
